import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Tabs,
  Tab,
  Stepper,
  Step,
  Drawer,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import axios from "axios";
import { useContext, useCallback, useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { loadAction } from "redux/reducers/top";
import { loginRequestAction, setUserInfoAction } from "redux/reducers/user";
import PropTypes from "prop-types";
import { Link, useHistory } from "react-router-dom";
import { Cookies, useCookies } from "react-cookie";
import DrawerTimer from "components/ui/drawer-timer";
import jwt_decode from "jwt-decode";
import AlertTimer from "components/ui/alert-timer";
import AlertComplete from "components/ui/alert-complete";
import AlertConfirm from "components/ui/alert-confirm";
import {
  getCryptoPwd,
  goCert,
  isJsonString,
  rem,
  setInitCookies,
} from "assets/js/common";
import { onlyNumber } from "assets/js/common";
import { stepAction, setUserAction } from "redux/reducers/join";
import { setAppData } from "assets/js/apphandle";
import moment from "moment";

const cookies = new Cookies();

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      className="tabpanel"
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {children}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  loginWrap: {
    // width: "100%",
    // maxWidth: "500px",
    // fontSize: "12px",
    // margin: "0 auto",
    "& .illust": {
      marginBottom: rem(30),
    },
    "& .layout-flex": {
      position: "relative",
      paddingTop: rem(20),
      minHeight: rem(285),
      "& .simple-login": {
        position: "relative",
        justifyContent: "flex-start",
        paddingLeft: rem(24),
        lineHeight: rem(22),
        fontSize: rem(14),
        color: theme.palette.info.main,
        fontWeight: 700,
        "&:before": {
          content: "''",
          position: "absolute",
          left: 0,
          top: 0,
          width: rem(22),
          height: rem(22),
          backgroundImage: `url(${process.env.PUBLIC_URL}/images/icon/icon-info-grey.svg)`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        },
      },
      "& .login-body": {
        paddingTop: rem(60),
      },
      ["@media (max-height:400px)"]: {
        "& .login-body": {
          paddingTop: rem(30),
        },
      },
      "& .layout-footer": {
        position: "absolute",
        left: rem(30),
        right: rem(30),
        bottom: rem(30),
      },
    },
  },
}));
// test
export default function Login(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const [data, setData] = useState("");
  const { user } = useSelector((state) => state.join);
  const [val, setVal] = useState(0);
  const [openAlert, setOpenAlert] = useState(false);
  const [alertMode, setAlertMode] = useState("");
  const [text, setText] = useState("");

  const [activeStep, setActiveStep] = useState(0);
  const [openComp, setOpenComp] = useState(false);
  const [mode, setMode] = useState("");
  const [render, setRender] = useState(false);
  const [open, setOpen] = useState(false);
  const [tag, setTag] = useState("");
  const [callback, setCallback] = useState("");
  const [isFocus, setIsFocus] = useState(false);

  const alertRef = useRef();
  const {
    userInfo,
    loginFail,
    loginFailReason,
    loginSuccess,
    loginResponseData,
  } = useSelector((state) => state.user);

  const {
    register,
    getValues,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      pw: "",
    },
  });

  const [checked, setChecked] = useState(true);

  const onSubmit = useCallback((data) => {
    dispatch(loginRequestAction(data));
  });

  const handleAlertTimerClose = () => {
    setOpenAlert(false);
  };

  const handleChangeTab = (event, newValue) => {
    setVal(newValue);
  };

  const handleAlertTimerOpen = () => {
    setOpenAlert(true);
    // alertRef.current.style.bottom = "41vh";
  };

  const handleSimpleClose = () => {
    setOpen(false);
  };

  const getParameterByName = (name) => {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
      results = regex.exec(location.search);
    return results == null
      ? ""
      : decodeURIComponent(results[1].replace(/\+/g, " "));
  };

  let vh = 0;

  useEffect(async () => {
    if (loginSuccess) {
      const myDecodedToken = jwt_decode(loginResponseData.accessToken);
      dispatch(setUserInfoAction(myDecodedToken));

      axios.defaults.headers.Authorization = `${loginResponseData.tokenType} ${loginResponseData.accessToken}`;

      // 쿠키넣기
      let cookieExpires = new Date();
      cookieExpires.setDate(cookieExpires.getDate() + 180);
      // console.log('cookieExpires', moment(cookieExpires));

      setInitCookies("expires", cookieExpires);
      setInitCookies(
        "X-AUTH-TOKEN",
        `${loginResponseData.tokenType} ${loginResponseData.accessToken}`
      );
      setInitCookies("X-REFRESH-TOKEN", loginResponseData.refreshToken);
      setInitCookies("no", loginResponseData.refreshToken);
      setInitCookies("checked", checked);

      if (loginResponseData.autoToken) {
        setInitCookies("autoToken", loginResponseData.autoToken);
      }

      let data = "";
      await axios.get("/api/mb/member/my-info").then((res) => {
        data = res.data.data;
        setInitCookies(
          "favInfo",
          JSON.stringify({
            defaultTp: data.member.mainTp || 1, //설정에서 세팅하는 tp
            visibleTp: data.member.mainTp || 1, //메인 화면에서 변경시키는 tp
            favMk: data.member.favMk,
            favMt: data.member.favMt,
          })
        );
      });

      window.loginComplete5 = function (authKey, pushUrl) {
        if (mode == "search") {
          props.history.replace("/password/search");
        } else {
          // editor page
          if (location.search) {
            let referrer = cookies.get("referrer") || "/";
            window.location.replace(referrer);
          } else {
            let state = props.location.state;
            history.replace(state ? state.from : "/");
          }
        }
        // location.href = `http://${window.location.host}/`;
        // _this.hideSplash();
      };

      if (window.Android) {
        window.Android.login(
          myDecodedToken.no,
          data.tag,
          data.member.mktPushYn,
          "loginComplete5"
        );
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.ios
      ) {
        // Call iOS interface
        var message = {
          command: "login",
          id: myDecodedToken.no,
          tag: data.tag,
          adYn: data.member.mktPushYn,
          func: "loginComplete5",
        };
        window.webkit.messageHandlers.ios.postMessage(message);
      } else {
        if (mode == "search") {
          props.history.push("/password/search");
        } else {
          // editor page
          if (location.search) {
            let referrer = cookies.get("referrer") || "/";
            window.location.replace(referrer);
          } else {
            let state = props.location.state;
            history.replace(state ? state.from : "/");
          }
        }
      }
    }
  }, [loginSuccess]);

  useEffect(() => {
    if (loginFail) {
      loginFailAlert(loginFailReason);
      setValue("pw", "");
      setActiveStep(0);
    }
  }, [loginFail]);

  const loadLogin = (tp, data) => {
    let form = "";
    if (getValues("pw") == "test99") {
      //guest 계정
      form = {
        grantType: tp,
        username: "guest",
        password: getValues("pw"),
      };
    } else if (tp == "password") {
      let no = cookies.get("no");
      const hashedPw = getCryptoPwd(getValues("pw"));
      form = {
        grantType: tp,
        username: no,
        password: hashedPw,
      };
    } else {
      form = {
        grantType: tp,
        username: null,
        password: null,
        ci: data.ci,
      };
    }
    setTimeout(() => {
      dispatch(loginRequestAction(form));
    }, 500);
  };

  const goAuthPage = (e, mode) => {
    e.preventDefault();
    setMode(mode);

    // window.loginReturnFunc = (data) => {
    //   alert('loginReturnFunc : '+ data)
    //   if (data) {
    //     setReturnData(decodeURI(data));
    //   } else {
    //     alert('본인 인증 오류입니다.')
    //   }
    // };
    goCert("loginReturnFunc");
  };

  const goJoinPage = () => {
    dispatch(
      setUserAction({
        ...user,
        ...data,
      })
    );
    dispatch(stepAction(2));
    history.push("/join/2");
  };

  const loadPassword = (result) => {
    if (result.pwd) {
      history.push("/password/search");
    } else {
      setAlertMode("noUser");
      setOpenComp(true);
    }
  };

  const [alertTimeOpen, setAlertTimeOpen] = useState(false);
  const handleAlertClose = () => {
    setAlertTimeOpen(false);
  };

  const setReturnData = (result) => {
    result = JSON.parse(result);
    setData(result);

    if (result.rst == "success") {
      if (result.isOrgUser === "true") {
        setAlertMode("isOrgUser");
        setOpenComp(true);
      } else if (result.isUser === "true") {
        if (result.isLev === "true") {
          setAlertMode("isLev");
          setOpenComp(true);
        } else if (mode == "search") {
          loadPassword(result);
        } else {
          loadLogin("cert", result);
        }
      } else {
        setAlertMode("noUser");
        setOpenComp(true);
      }
    } else {
      alert("본인 인증 오류");
    }
  };

  const loginFailAlert = (text) => {
    let el = document.getElementById("ghostInput");
    if (el) el.blur();
    setText(text);
    setTimeout(() => {
      handleAlertTimerOpen();
      setValue("pw", "");
    }, 100);
  };
  useEffect(() => {
    // setValue("pw", onlyNumber(getValues("pw")));
    setValue("pw", getValues("pw"));
    setActiveStep(getValues("pw").length);

    if (getValues("pw").length == 6) {
      const no = cookies.get("no");
      if (no || getValues("pw") == "test99") {
        loadLogin("password");
      } else {
        loginFailAlert(
          "최초 본인인증을 진행하신 뒤 간편 비밀번호를 입력해주세요"
        );
      }
    }
  }, [watch("pw")]);

  const { init } = useSelector((state) => state.top);
  useEffect(() => {
    if (init) dispatch(loadAction({ back: true, title: "로그인", menu: true }));
  }, [init]);

  useEffect(() => {
    //app return
    window.loginReturnFunc = (data) => {
      let no = cookies.get("no");

      if (data) {
        setReturnData(decodeURI(data));
      } else {
        alert("본인인증 오류입니다.");
      }
    };

    //web test
    const receiveMessage = async (e) => {
      if (isJsonString(e.data)) {
        setReturnData(e.data);
      }
    };
    window.addEventListener("message", receiveMessage, false);

    let checked = cookies.get("checked");
    setChecked(checked == "false" ? false : true);

    let el = document.getElementById("ghostInput");
    if (el) el.focus();
  }, []);

  window.appBackKeyHandle = () => {
    if (open) {
      setOpen(false);
    } else if (openComp) {
      if (alertMode == "noUser" || alertMode == "isLev") {
        setOpenComp(false);
      } else if (alertMode == "isOrgUser") {
        goJoinPage();
      } else {
        history.replace("/");
      }
    } else {
      history.goBack();
    }
  };

  return (
    <>
      <main
        id="main simple-login"
        className={"container nopad " + classes.loginWrap}
      >
        {
          <>
            <Tabs
              value={val}
              onChange={handleChangeTab}
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab label="휴대폰 인증" />
              <Tab label="간편 비밀번호" />
            </Tabs>
            <TabPanel value={val} index={0}>
              <div className="layout-flex">
                <div className="layout-body login-body">
                  <p className="text-top">
                    휴대폰 인증으로
                    <br />
                    편리하게 로그인하세요!
                  </p>
                  <Box className="illust" mt={8}>
                    <img
                      src={`${process.env.PUBLIC_URL}/images/img/illust-login.svg`}
                    />
                  </Box>
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    mt={6}
                    onClick={goAuthPage}
                  >
                    인증하기
                  </Button>
                  <Box mt={6}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          icon={<span className="checkbox-icon" />}
                          checkedIcon={
                            <span className="checkbox-icon-checked" />
                          }
                        />
                      }
                      checked={checked}
                      onChange={(e) => {
                        setChecked(e.target.checked);
                        cookies.set("checked", e.target.checked);
                      }}
                      label="자동로그인"
                    />
                  </Box>
                </div>
                <div className="layout-footer">
                  <div className="layout-link">
                    <Link to={"/join/1"} className="right">
                      회원가입
                      <i className="ico-next" />
                    </Link>
                  </div>
                </div>
              </div>
            </TabPanel>
            <TabPanel value={val} index={1}>
              <div className="layout-flex">
                <Button
                  className="simple-login"
                  onClick={() => {
                    setOpen(true);
                  }}
                >
                  간편 비밀번호란?
                </Button>
                <div className="layout-body login-body">
                  <p className="text-top">숫자 6자리를 입력해주세요</p>
                  <div className="stepper-cont">
                    <div className="stepper-pw">
                      <Stepper activeStep={activeStep} alternativeLabel>
                        {Array.from(Array(6)).map((_, index) => (
                          <Step key={index} />
                        ))}
                      </Stepper>
                      <input
                        // type="tel"
                        type="text"
                        id="ghostInput"
                        {...register("pw")}
                        autoComplete="off"
                        className="ghost-input"
                        maxLength="6"
                        autoFocus
                        onFocus={() => {
                          if (
                            window.webkit &&
                            window.webkit.messageHandlers &&
                            window.webkit.messageHandlers.ios
                          )
                            setIsFocus(true);

                          handleAlertTimerClose();
                        }}
                        onBlur={() => {
                          if (
                            window.webkit &&
                            window.webkit.messageHandlers &&
                            window.webkit.messageHandlers.ios
                          )
                            setIsFocus(false);
                        }}
                      />
                    </div>
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          icon={<span className="checkbox-icon" />}
                          checkedIcon={
                            <span className="checkbox-icon-checked" />
                          }
                        />
                      }
                      checked={checked}
                      onChange={(e) => {
                        setChecked(e.target.checked);
                        cookies.set("checked", e.target.checked);
                      }}
                      label="자동로그인"
                    />
                  </div>
                  {/* <p className="info-txt">
                간편 비밀번호는 로그인을 위해 꼭 필요한 정보입니다.
                <br />
                잊어버리지 않도록 주의하세요.
              </p> */}
                  <AlertTimer
                    open={openAlert}
                    handleAlertTimerClose={handleAlertTimerClose}
                    text={text}
                  />
                </div>
                <div
                  className="layout-footer"
                  style={{ bottom: isFocus === true ? "42%" : rem(30) }}
                >
                  <div className="layout-link">
                    <Link
                      to={""}
                      onClick={(e) => {
                        goAuthPage(e, "search");
                      }}
                      className="left"
                    >
                      <i className="ico-back" />
                      비밀번호찾기
                    </Link>
                    <Link to={"/join/1"} className="right">
                      회원가입
                      <i className="ico-next" />
                    </Link>
                  </div>
                </div>
              </div>
            </TabPanel>
          </>
        }
        {/* <DrawerTimer
          open={alertTimeOpen}
          handleDrawerClose={handleAlertClose}
          text={"간편비밀번호가 변경되었습니다"}
        /> */}
        {
          // alertMode == "noUser" ? (
          //   <AlertComplete
          //     open={openComp}
          //     handleAlertClose={() => {
          //       setOpenComp(false);
          //     }}
          //     text="회원가입되지 않은 사용자입니다. 회원가입을 먼저 진행해주세요."
          //     action={() => {
          //       setOpenComp(false);
          //     }}
          //   />
          // ) :
          alertMode == "isOrgUser" ? (
            <AlertComplete
              open={openComp}
              handleAlertClose={goJoinPage}
              text={
                "고객님은 이미 메가마트 회원입니다.<br/>추가 정보를 입력하고 회원가입을 완료하세요."
              }
              action={goJoinPage}
            />
          ) : alertMode == "isLev" ? (
            <AlertComplete
              open={openComp}
              handleAlertClose={() => {
                setOpenComp(false);
              }}
              text="현재 고객님은 회원탈퇴 중입니다.<br/>메가마트 멤버십 앱을 사용하시려면 회원탈퇴 7일 후 재가입 해주세요."
              action={() => {
                setOpenComp(false);
              }}
            />
          ) : (
            <AlertConfirm
              open={openComp}
              handleAlertClose={() => {
                history.replace("/");
              }}
              text="등록된 회원정보가 없습니다.<br/>지금 바로 회원가입하시겠습니까?"
              action={goJoinPage}
            />
          )
        }
      </main>
      <Drawer
        anchor="bottom"
        open={open}
        onClose={() => {
          handleSimpleClose(false);
        }}
        className="drawer-common-bottom size-small simple-drawer"
      >
        <div className="drawer-body">
          <div className="info align-c">
            <div className="illust">
              <img src={`${process.env.PUBLIC_URL}/images/icon/question.svg`} />
            </div>
            <Box className="text" mt={6}>
              <strong>간편 비밀번호란?</strong>
              <div>
                <p>
                  간편비밀번호를 등록하시면,
                  <br />
                  6자리 숫자 입력으로
                  <br />
                  간편하게 로그인하실 수 있습니다.
                </p>
                <p>
                  휴대폰 본인인증을 통한 회원가입
                  <br />
                  또는 로그인 후 [간편 비밀번호 설정]에서
                  <br />
                  등록 가능합니다.
                </p>
              </div>
            </Box>
          </div>
        </div>
        <div className="drawer-foot">
          <Button
            color="primary"
            variant="contained"
            onClick={() => {
              handleSimpleClose(false);
            }}
          >
            확인
          </Button>
        </div>
      </Drawer>
    </>
  );
}
